import api from "./api";

const dealerService = {
  getDealers: async () => {
    const response = await api.get("/admin/dealers");
    return response.data;
  },

  createDealer: async (data) => {
    const response = await api.post("/admin/create-dealer", data);
    return response.data;
  },

  updateDealerStatus: async (data) => {
    const response = await api.patch("/admin/dealer-status", data);
    return response.data;
  },

  getHierarchy: async () => {
    const response = await api.get("/admin/hierarchy");
    return response.data;
  },

  generateCoins: async (data) => {
    const response = await api.post("/admin/generate-coins", data);
    return response.data;
  },

    transferToDealer: async (data) => {
    const response = await api.post("/admin/transfer-to-dealer", data);
    return response.data;
  },

  deleteDealer: async (dealerId) => {
    const response = await api.delete(`/admin/dealers/${dealerId}`);
    return response.data;
  }
};

export default dealerService;